// @ts-nocheck
 
 
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  createStyles,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,

 IconButton } from '@material-ui/core';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import { useTypedSelector } from 'helpers';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { basicButtonStyles, tableRowStyles } from 'app/shared/styles';
import { TextCell } from 'app/components/shared/table';
import { Modal,  Form, Spinner } from "react-bootstrap";
import OrgComTypTable from './components/orgComTypTable';
const useStyles = makeStyles(() =>
  createStyles({
    table: { minWidth: 750, overflow: 'scroll', whiteSpace: 'nowrap' },
    addButton: { ...basicButtonStyles },
    row: { ...tableRowStyles },
  })
);
const ViewMerchantPOS = () => {
  const classes = useStyles();
  const [merchantName, setMerchantName] = useState('');
  const [merchantEnName, setMerchantEnName] = useState('');
  const [com_type_ar_name, setCom_type_ar_name] = useState('');
  const [com_type_en_name, setCom_type_en_name] = useState('');
  const [merchent_ID, setMerchantId] = useState(null);
  const [merchants, setMerchants] = useState([]);
  const [merchantStatus, setMerchantStatus] = useState(null);
  const [pos_user_name, setPosUserName] = useState('');
  const [pos_name, setPosName] = useState('');
  const [pos_pass, setPosPass] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pos_serial_number, setPosSerialNumber] = useState('');
  const [sam_UID, setSamUID] = useState('');
  const [sim_MSIDN, setSimMSIDN] = useState('');
  const [pos_user_limit, setUserLimit] = useState('');
  const [merchant_pos_status, setMerchantPosStatus] = useState(1);
  const [isFormLoading, setIsFormLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
  const intl = useIntl();
  const history = useHistory();
  const [deleteResponse, setDeleteResponse] = useState(null); 
  const [update_organisation_commission_typeResponse, setupdate_organisation_commission_typeResponse] = useState(null); 
  const [remove_organisation_commission_typeResponse, setremove_organisation_commission_typeResponse] = useState(null); 

  const [organisationCommissionTypes, setOrganisationCommissionTypes] = useState([]);
  const [commission_type_id, setCommission_type_id] = useState(null);
  let userPersonalData = '';
  let userAuthData = '';
  const authData = localStorage.getItem("authData");
  const [showPassword, setShowPassword] = useState(false);
  if (authData !== null) {
    const parsedAuthData = JSON.parse(authData);
    userPersonalData = parsedAuthData.userData;
    userAuthData = parsedAuthData.userToken;
  }

  // Fetch merchant data
  useEffect(() => {
    const fetchMerchantPOS = async () => {
      setIsFormLoading(true);
      setError(null);
      try {
        let url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/getMerchantPOS`;
        const response = await axios.post(url, {
           PersonID: id 
        }, {
            headers: {
              'access-token': userAuthData?.access_token,
              'uid': userAuthData?.uid,
              'client': userAuthData?.client,
            },
          });
          const merchantPOS = response.data.data;
          setPosName(merchantPOS.email); 
          setPosPass(merchantPOS.pass);
          setPosSerialNumber(merchantPOS.pos_serial_number);
          setSamUID(merchantPOS.sam_uid);
          setSimMSIDN(merchantPOS.sim_msidn);
          setMerchantId(merchantPOS.merchent_id);
          setPosUserName(merchantPOS.user_name);
          setUserLimit(merchantPOS.user_limit);
          setMerchantPosStatus(merchantPOS.status);
          setMerchantName(merchantPOS.merchant_name);
          setMerchantEnName(merchantPOS.merchant_en_name);
          setMerchantStatus(merchantPOS.merchant_status);
          setCom_type_ar_name(merchantPOS.com_type_ar_name);
          setCom_type_en_name(merchantPOS.com_type_en_name);
          setCommission_type_id(merchantPOS.commission_type_id);
      } catch (error) {
        setError(`Failed to fetch merchant POS [${error}]`);
        toast.error(`Failed to fetch merchant POS [${error}]`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      } finally {
        setIsFormLoading(false);
      }
    };

    fetchMerchantPOS();
  }, [deleteResponse]);

  const hasPOSWriteAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'MerchantPOS')
  );
  const deleteMerchantPOS = async (pos_name, pos_pass, pos_serial_number, sam_UID, sim_MSIDN, merchent_ID, pos_user_name, pos_user_limit, id) => {
    setIsLoading(true);
    try {
      let url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/updateMerchantPOS`;
      const response = await axios.post(url, {
        Email: pos_name,
        Pass: pos_pass,
        pos_Serial_number: pos_serial_number,
        sam_UID: sam_UID,
        sim_MSIDN: sim_MSIDN,
        merchent_ID: merchent_ID,
        USER_NAME: pos_user_name,
        USER_LIMIT: pos_user_limit,
        STATUS: 3,
        PersonID: id
      }, {
        headers: {
          'access-token': userAuthData?.access_token,
          'uid': userAuthData?.uid,
          'client': userAuthData?.client,
        },
      });
      setDeleteResponse(response.data)
      toast.success('Merchant POS Deleted successfully!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        toastStyle: {
          backgroundColor: '#F1662D',
          color: 'white',
        },
      });


    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.message) {

        toast.error(`[${error.response.data.message}]`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      } else {

        toast.error(`[${error}]`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const get_organisations_commission_types = () => {
      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/get_organisations_commission_types`;

      setIsLoading(true);

      axios.post(url, {
        UUID_VALUE: commission_type_id 
     },{
        headers: {
          'access-token': userAuthData?.access_token,
          'uid': userAuthData?.uid,
          'client': userAuthData?.client,
        }
      })
        .then((res) => {
          setOrganisationCommissionTypes(res.data.data);
    
          setIsLoading(false);
        })
        .catch((err) => {
          console.error("API ERROR", err);
          toast.error(`Sorry, ${err.message}. Please try again later.`);
          setIsLoading(false);
        });
    };

    commission_type_id &&  get_organisations_commission_types();
  }, [commission_type_id]);

  const update_organisation_commission_type = async (COM_PROV, COM_RET, FLAT_FEE, VAT, organisation_commission_type_id) => {
    setIsLoading(true);
    try {
      let url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/update_organisation_commission_type`;
      const response = await axios.post(url, {
        COM_PROV: COM_PROV,
        COM_RET: COM_RET,
        FLAT_FEE: FLAT_FEE,
        VAT: VAT,
        organisation_commission_type_id: organisation_commission_type_id
      }, {
        headers: {
          'access-token': userAuthData?.access_token,
          'uid': userAuthData?.uid,
          'client': userAuthData?.client,
        },
      });
      setupdate_organisation_commission_typeResponse(response.data)
      toast.success(' updated successfully!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        toastStyle: {
          backgroundColor: '#F1662D',
          color: 'white',
        },
      });


    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.message) {

        toast.error(`[${error.response.data.message}]`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      } else {

        toast.error(`[${error}]`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };
  const remove_organisation_commission_type = async (organisation_commission_type_id) => {
    setIsLoading(true);
    try {
      let url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/remove_organisation_commission_type`;
      const response = await axios.post(url, {
    
        organisation_commission_type_id: organisation_commission_type_id
      }, {
        headers: {
          'access-token': userAuthData?.access_token,
          'uid': userAuthData?.uid,
          'client': userAuthData?.client,
        },
      });
      setremove_organisation_commission_typeResponse(response.data)
      toast.success(' deleted successfully!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        toastStyle: {
          backgroundColor: '#F1662D',
          color: 'white',
        },
      });


    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.message) {

        toast.error(`[${error.response.data.message}]`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      } else {

        toast.error(`[${error}]`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };
// START ADD ORGANISATION COMMISSION TYPE
const [show, setShow] = useState(false);
const [formData, setFormData] = useState({
  ORGANISATION_ID: "",
  commission_type_id: "",
  COM_PROV: "",
  COM_RET: "",
  FLAT_FEE: "",
  VAT: "",
});
const [commissionTypes, setCommissionTypes] = useState<any[]>([]);
const [organisations, setOrganisations] = useState([]);
const [message, setMessage] = useState({ type: "", text: "" });
const [loading, setLoading] = useState(false);
const [dropdownLoading, setDropdownLoading] = useState(true);

const handleShow = () => setShow(true);
const handleClose = () => {
  setShow(false);
  setMessage({ type: "", text: "" });
  setFormData({
    ORGANISATION_ID: "",
    commission_type_id: "",
    COM_PROV: "",
    COM_RET: "",
    FLAT_FEE: "",
    VAT: "",
  });
};

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};

// Load organisations and commission types
useEffect(() => {
  const fetchDropdowns = async () => {
    try {
      const [orgRes, commRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/fareMedia/get_organisations`, {
          headers: {
            'access-token': userAuthData?.access_token,
            'uid': userAuthData?.uid,
            'client': userAuthData?.client,
          }
        }) ,
        axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/get_commission_types`,{
          headers: {
            'access-token': userAuthData?.access_token,
            'uid': userAuthData?.uid,
            'client': userAuthData?.client,
          }
        })
      ]);

      setOrganisations(orgRes.data.data || []);
      setCommissionTypes(commRes.data.data || []);
    } catch (err) {
      console.error("Error loading dropdowns", err);
      setMessage({ type: "danger", text: "Failed to load dropdown data." });
    } finally {
      setDropdownLoading(false);
    }
  };

  fetchDropdowns();
}, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage({ type: "", text: "" });

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/merchantPOS/add_organisation_commission_type`,
      formData
    );

    const { success, message: resMsg } = response.data;

    if (success) {
      setMessage({ type: "success", text: "Commission type added successfully." });
      setTimeout(() => handleClose(), 1000);
    } else {
      setMessage({ type: "danger", text: resMsg });
    }
  } catch (err) {
    console.error(err);
    setMessage({ type: "danger", text: "Server error. Please try again later." });
  } finally {
    setLoading(false);
  }
};

// END ADD ORGANISATION COMMISSION TYPE
  return (
    <>
      <Box sx={{  marginTop: -5, padding: 4 }}>
        <Typography sx={{ color: '#252733',fontWeight:"bold",marginBottom:"16px" }}>
          {intl.formatMessage({ id: 'MerchantPOSInfo' })}
        </Typography>
        <div style={{display:"flex" ,flexWrap:"wrap",justifyContent:"space-between"}} >
        {isFormLoading ? (
          <CircularProgress  style={{display:"block"}}/>
        ) : (

          <>
            <div className='table-view-item-info' style={{width:"98%"}}>
                <div className="name-and-actions-btns-sec">
                    <h5 className="title-item-sec">
                        {pos_user_name}
                    </h5>
                    <div className="actions-btns-sec">
                    {hasPOSWriteAccess && 
                        <> <button className="styleAddBtn" style={{position:"inherit",marginTop:"-10px",paddingBottom:"7px",paddingTop:"8px"}}  onClick={()=>history.push(`/CardsManagement/merchantPOS/${id}/edit?came_from=one`)}>
                           <EditIcon style={{fontSize:"24px",paddingRight:"3px",paddingLeft:"3px"}} /> {intl.formatMessage({ id: 'edit' })}
                        </button>
                        {merchant_pos_status !=3 &&<><button  className="styleAddBtn"  data-bs-toggle="modal" style={{backgroundColor:"#D54C5E",position:"inherit",marginLeft:"5px",marginRight:"5px",marginTop:"-10px",paddingBottom:"7px",paddingTop:"8px"}} 
                           data-bs-target={"#exampleModal4"+ id }>
                          <DeleteIcon style={{fontSize:"24px",paddingRight:"3px",paddingLeft:"3px"}}/> {intl.formatMessage({ id: 'Delete' })}  </button>
                        <div className="modal fade" style={{zIndex:"9999969"}} id={"exampleModal4"+ id} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                             
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div className="modal-body">
                                <h5>  {currentLanguageCode == "en-us" ? `Are You Sure You Want To Delete ${pos_user_name}` : `هل أنت متأكد انك تريد حذف ${pos_user_name}`}</h5>
                                </div>
                              <div className="modal-footer" style={{direction:currentLanguageCode == "en-us" ? "ltr":"rtl"}}>
                              <button type="button" className="btn btn-outline-dark" data-bs-dismiss="modal">{intl.formatMessage({ id: 'Cancel' })} </button>
                                <button type="button" 
                                className="btn btn-danger"data-bs-dismiss="modal"
                                
                              onClick={()=>deleteMerchantPOS(pos_name, pos_pass, pos_serial_number, sam_UID, sim_MSIDN, merchent_ID, pos_user_name, pos_user_limit, id)}>{intl.formatMessage({ id: 'Delete' })} </button>
                          
                              </div>
                            </div>
                          </div>
                        </div></>}</>}

                    </div>
                </div>
                <div className="data-view-sec display-data-view-sec">
<div  className="one-div">
                <div className="one-info ">
                        <div className="title-of-one-info">
                            {intl.formatMessage({ id: 'POSName' })}
                        </div>
                        <div className="value-of-one-info">
                           {pos_user_name}
                        </div>
                    </div>
                    <div className="one-info">
                        <div className="title-of-one-info">
                            {intl.formatMessage({ id: 'Name' })}
                        </div>
                        <div className="value-of-one-info">
                           {pos_name}
                        </div>
                    </div>
                    <div className="one-info">
                        <div className="title-of-one-info">
                            {intl.formatMessage({ id: 'POSStatus' })}
                        </div>
                        <div className="value-of-one-info">
                           
                           {merchant_pos_status == 1 ?<CheckCircleIcon style={{color:"#81D135"}}/>:merchant_pos_status == 2 ?<CheckCircleIcon style={{color:"black"}}/>:<CheckCircleIcon style={{color:"red"}}/>}
                        </div>
                    </div>
                    <div className="one-info">
                        <div className="title-of-one-info">
                            {intl.formatMessage({ id: 'MerchantName' })}
                        </div>
                        <div className="value-of-one-info">
                           { merchantEnName} - { merchantName }
                        </div>
                    </div>
                    <div className="one-info">
                        <div className="title-of-one-info">
                            {intl.formatMessage({ id: 'MerStatus' })}
                        </div>
                        <div className="value-of-one-info">
                           
                           {merchantStatus == 1 ?<CheckCircleIcon style={{color:"#81D135"}}/>:merchantStatus == 2 ?<CheckCircleIcon style={{color:"black"}}/>:<CheckCircleIcon style={{color:"red"}}/>}
                        </div>
                    </div>
                    <div className="one-info">
                        <div className="title-of-one-info">
                            {intl.formatMessage({ id: 'commissionType' })}
                        </div>
                        <div className="value-of-one-info">
                        {currentLanguageCode === "en-us" ? com_type_en_name : com_type_ar_name}
                        </div>
                    </div>
                    </div>
                    <div  className="one-div-middle"></div> 
                    <div  className="one-div">
                     
                    <div className="one-info">
                        <div className="title-of-one-info">
                         {intl.formatMessage({ id: 'POSSerialNumber' })}
                        </div>
                        <div className="value-of-one-info">
                           {pos_serial_number} 
                        </div>
                    </div> 
                    <div className="one-info">
                        <div className="title-of-one-info">
                          SAM UID
                        </div>
                        <div className="value-of-one-info">
                           {sam_UID}
                        </div>
                    </div> 
                    <div className="one-info">
                        <div className="title-of-one-info">
                           SIM MSIDN
                        </div>
                        <div className="value-of-one-info">
                           {sim_MSIDN}
                        </div>
                    </div>
                    <div className="one-info">
                        <div className="title-of-one-info">
                        {intl.formatMessage({ id: 'UserLimit' })}
                        </div>
                        <div className="value-of-one-info">
                           {pos_user_limit}
                        </div>
                    </div>
                  
                    <div className="one-info">
                        <div className="title-of-one-info" style={{marginTop:"11px"}}>
                            {intl.formatMessage({ id: 'Password' })}
                        </div>
                        <div className="value-of-one-info">
                       
                          <div className="inputPasswordContainer" style={{ display: "flex", alignItems: "center" }}>
    <input
      type={showPassword ? "text" : "password"}
      className="inputStylePassword inputStylePassword-in-view"
      id="password"
      value={pos_pass}
      disabled
      required
      style={currentLanguageCode == "en-us" ? { flex: 1 ,marginLeft:"35px"}:{ flex: 1 ,marginRight:"35px"}} // Make the input take up available space
    />
    <IconButton
      className="visibIcon"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <VisibilityOff /> : <Visibility />}
    </IconButton>
  </div>
                        </div>
                    </div>
                
                </div></div>
            </div>
       
          </>
        )}


</div>

  {/* start organisation commission type section  */}
<OrgComTypTable  
    //  states values
     commission_type_id={commission_type_id}
     isLoading={isLoading} 
     organisationCommissionTypes={organisationCommissionTypes}
     hasCommissionsWriteAccess={undefined}
     editingRowId={undefined}
     editFormData={undefined}
     organisations={organisations}
     isAddingRow={undefined}
     com_type_is_multi={undefined}
     formData={undefined}
     com_type_en_name={com_type_en_name}
     com_type_ar_name={com_type_ar_name}
     //states setters
     setIsLoading={setIsLoading}
     setOrganisationCommissionTypes={setOrganisationCommissionTypes}  
     setEditFormData={undefined}
     setFormData={undefined}
     setCom_type_is_multi={undefined}
     setCom_type_ar_name={setCom_type_ar_name}
     setCom_type_en_name={setCom_type_en_name}
     //functions 
     handleEditFormChange={undefined}
     handleSaveEditRow={undefined} 
     handleCancelEditRow={undefined}
     handleEditRow={undefined} 
     handleChange={undefined}
     handleAddNewRow={undefined} 
     handleCancelAddRow={undefined}
     handleAddRow={undefined}
     remove_organisation_commission_type={undefined}
        
      />
 {/* end organisation commission type section  */}

         <button
           className='cancelBtnStyle'
           style={{marginTop:"20px"}}
            onClick={() => history.push(`/CardsManagement/merchantPOS/`)}
          >
            {intl.formatMessage({ id: 'BackToMerchantPOS' })}
          </button>
      </Box>
      <ToastContainer /></>
    
  );
};

export default ViewMerchantPOS;
